module.exports = __webpack_public_path__ + "static/media/s7.5ace3298.png";